import { create } from 'zustand';

interface SmartOfferStore {
  showSmartOffer: boolean;
  setShowSmartOffer: (showSmartOffer: boolean) => void;
  showInLineSmartOffer: boolean;
  setShowInLineSmartOffer: (showInLineSmartOffer: boolean) => void;
  currentPathname: string | null;
  setCurrentPathname: (currentPathname: string | null) => void;
}

export const useSmartOfferStore = create<SmartOfferStore>()((set) => ({
  showSmartOffer: true,
  setShowSmartOffer: (showSmartOffer: boolean) => set({ showSmartOffer }),
  showInLineSmartOffer: false,
  setShowInLineSmartOffer: (showInLineSmartOffer: boolean) => set({ showInLineSmartOffer }),
  currentPathname: null,
  setCurrentPathname: (currentPathname: string | null) => set({ currentPathname }),
}));
